//navigator geolocation konstanty
const GEOLOCATION_PERMISSION_DENIED = 1;
const GEOLOCATION_POSITION_UNAVAILABLE = 2;
const GEOLOCATION_TIMEOUT = 3;

//konstanty pro zmeny zobrazeni
const mapView = 'mapView';
const branchesView = 'branchesView';
const displayModeDesktop = 'displayModeDesktop';
const displayModePhone = 'displayModePhone';
const windowWidthSM = 768;
const mapHtmlDivID = 'map';

//konstanty pro getDeliveryImageUrl
const deliveryImageIcon = 'deliveryImageType_icon';
const deliveryImageMarker = 'deliveryImageType_marker';
const deliveryImageLogo = 'deliveryImageType_logo';

let countryDeliveriesData = null; //object s daty vsech doprav pro danou country, nastavi se v getCountryDeliveriesData (cena dopravy se aktualizuje pak pri kazdem ajaxComplete -> zmeni se data v toggleButtonu a to zmeni data v obejctu)
let mapCenterCoordinates = null; //souradnice, kam se ma mapa vycentrovat: object ve tvaru {lng: 15.842146, lat: 49.802545, zoom: 7};
let map = undefined; //lefalet map variable (L.map)
let mapModal = document.getElementById("modal-leaflet-map");
let isOnBranchPage = false; //jestli je mapa na strance s pobockami
let branchesInArea = []; //pole objektů s daty o branchich v okoli prave zvolene branche/bodu na mape
let remainingBranches = null; //pocet branchi, ktere se mohou jeste nacist z DB pri scrollovani v branchesListu
let isNearGigaprintBranchAsFirstResult = false; //jestlize je pobocka liptal nebo praha v okoli 30km, prida se jako prvni vysledek do branchesList (pri nacitani dalsich pobocek v branchesListu uz se podle teto variable neprida duplikat)
let phoneView = branchesView; //po nacteni se na telefonu zobrazuje "tab" s pobockami
let displayMode = getDisplayMode();
let activeMarkerCoords = null; //souradnice momentalne zvoleneho bodu/branche, object ve tvaru object {lng: lat:}
let activeBranchID = null; //ID naposled kliknute branche
let selectedBranchID = null; //ID branche zvolene k doprave
let positionMarker = null; //marker pro autocompletejs adresu - lat,lng
let mcg = null; //leaflet markerClusterGroup instance
let root = null; //treeNode root, nastavuje se v createMarkerSubGroupsTree()
let control = null; //variable pro pridani checkboxu k togglovani subGroups (pouzite uz jen k debugovani)
let isInfiniteScrollLoading = false; //bool variable, ktera pri scrollovani zamezuje nekolikanasobnemu volani loadMoreBranchesInList()
let checkboxes = document.querySelectorAll(".branches-leaflet__modal__content__menu__checkbox");

//variables z BranchesMapController.php (nastavi se uvnitr setLeafletMapVariablesFromLaravel())
let apiKey = null;
let app_country_id = null; //1=CZ , 2=SK, 7=HU
let allDeliveriesData  = null; //pole s informacemi o vsech moznych dopravach
let activeDeliveryIDs = null; //pole IDcek prave zvolenych filtru doprav
let deliveryFilterGroups = null; // pole filtrů pro kazdy filterGroup (napr branch_type[box/shop], payment_type[cash,card])
let activeMarkerFilters = null; //pole prave zvolenych typů filtrů (pobočka,platba kartou,...)
let defaultActiveMarkerCoordinatesFromLaravel = null; //default zvolena souradnice, ktera vznikne pokud uzivatel odmitne polohu
let taxDocumentID = null;  //pokud je set, tak mapa slouzi ke zmene pobocky (v pubu) v dokoncene objednavce
let langTexts = null;

//url variables
let webBaseUrl = window.location.origin; //base url webu gigaprint
let setBranchRouteUrl = '/component/Configurator-DeliveryConfigurator/setBranch'; //path (za base url) na actionSetBranch z deliveryConfiguratoru
let setBranchRedirectUrl = null; //redirect url po zvoleni pobocky jako odberne misto - nastavi se v setLeafletMapVariablesFromLaravel()
let setBranchRedirectUrl_isOnBranchPage; // redirect url po zvoleni pobocky jako odberneho mista na strance kde-nas-najdete - nastavi se v setLeafletMapVariablesFromLaravel()
let redirectBackToPubUrl = null; //redirect url zpet do pub/orders po zvoleni nove pobocky - nastavi se v setLeafletMapVariablesFromLaravel()
let setDelivery = 'component/Order-Deliveries/setDelivery'; //nastaveni jineho typu dopravy (! ne branche)

let iconPositionUrl = '/obr/icon/icon_position.svg';

$(document).on("ajaxComplete", function(event, xhr, settings) {
    //modal s mapou se zavre az se dokonci action prepnuti branche
    if(settings.url.includes(setBranchRouteUrl) )
    {
        closeMapModal();
        if(xhr.status === 200){
            var jsonData = JSON.parse(settings.data);
            var branchId = jsonData.data.branch;
            if(branchId)
            {
                selectedBranchID = parseInt(branchId);
                updateBranchListItemSelectedBranch();
            }

            setTimeout(() => {
                showNotification('branches-leaflet__notification-branch-select-success');
            }, 0);
        }
        else{
            setTimeout(() => {
                showNotification('branches-leaflet__notification-branch-select-error');
            }, 0);
        }
    } else {
        if(activeMarkerCoords !== null && xhr.status === 200){
            var jsonData = JSON.parse(settings.data);
            if(jsonData.parts !== undefined && jsonData.parts.includes("component-Order-Deliveries-1")) {
                updateBranchesList(activeMarkerCoords, false);
            }
        }

       //pokud se zmeni doprava z branche treba na PPL, tak se ze naposled vybrane pobocky odstrani "vybráno":
        if(settings.url.includes(setDelivery) && xhr.status === 200){
            selectedBranchID = null;
            updateBranchListItemSelectedBranch();
        }
    }

    if(countryDeliveriesData !== null){
        updateDeliveriesDataPrices();
    }
});

$(document).ready(function() {
    if($(mapModal).hasClass('branches-leaflet--branches-page')) {
        isOnBranchPage = true;
        openMap();
    }
    $(document).on('click', '#modal-leaflet-map__open-btn', function() {
        openMap();
    });

    checkboxes.forEach(function(checkbox) {
        checkbox.addEventListener("click", function(event)
        {
            handleCheckboxClick(event);
        });
    });

    $(document).on('click', 'a.branches-leaflet__branch__show-detail-btn' , function() {
        var showDetailBtn = $(this);
        toggleBranchItemDetails(showDetailBtn);
    });

    $(document).on('click', '.branches-leaflet__branch__show-branch-on-phone-btn-wrapper a', function() {
        var showBranchOnMapButton = $(this);
        var branch_id = showBranchOnMapButton.closest('.branches-leaflet__branch__wrapper').data('branch-item-marker-id');
        showBranchOnMobileMap(branch_id);
    });

    $(document).on('click', '.modal-leaflet-map__close', function () {
        closeMapModal();
    });

    $(document).on('click', '.branches-leaflet__popup-card__header__close-btn .icon--close-medium', function() {
        closeCard();
    });

    $(document).on('click', '.branches-leaflet__modal__checkboxes__filters-toggle-button', function() {
        resizeMapAfterTogglingFilters();
    });

    $(document).on('mousedown', function(event) {
        if (event.target == mapModal) {
            closeMapModal();
        }
    });

    $(document).on('keydown', function(event) {
        if (event.key == "Escape" && typeof map !== "undefined") {
            if(taxDocumentID){
                var modal = $('.change-order-branch-leaflet__update-modal__container');
                modal.addClass('change-order-branch-leaflet__update-modal__container--hidden');
            }
            if(typeof map !== "undefined" && map._popup && map._popup.isOpen())
            {
                //pokud je otevreny popup-card zavola se map.closePopup() definovanvy v eventlisteneru uvnitr resolveMapLoad()
            } else {
                closeMapModal();
            }
        }
    });

    $(document).on('click', '#phone-tab__branches', function (event) {
        var showBranchesInput  = event.target.id;
        toggleView(showBranchesInput);
    });

    $(document).on('click', '#phone-tab__map', function (event) {
        var showMapInput  = event.target.id;
        toggleView(showMapInput);
    });

    $( window ).on( "resize", function() {
        toggleView('resize');
    });

    $('.branches-leaflet__modal__content__menu__branches-list').on("scroll", function() {
        var element = $(event.target);
        var scrolledFromTopPercent = (element.scrollTop())/(element[0].scrollHeight - element.outerHeight());
        var loadConditionPercent = 0.975;

        if(scrolledFromTopPercent > loadConditionPercent && !isInfiniteScrollLoading)
        {
            isInfiniteScrollLoading = true;
            loadMoreBranchesInList();
        }

        if (scrolledFromTopPercent <= loadConditionPercent) {
            isInfiniteScrollLoading = false;
        }
    });

    $('.branches-leaflet__modal__content__menu__suggest__location-icon').on('click', function() {
        var locationPromise = getLocationPromise();
        toggleAjaxLoading(mapHtmlDivID);
        toggleAjaxLoading('branches-leaflet__modal__content__menu__branches-list');
        locationPromise
            .then(function(result) {
                mapCenterCoordinates = result;
                activeMarkerCoords = {lng:mapCenterCoordinates.lng, lat:mapCenterCoordinates.lat};
                createMarkerAtLocation(activeMarkerCoords);
                map.setView([activeMarkerCoords.lat,activeMarkerCoords.lng],17);
            })
            .catch(function(err) {
                if (typeof err === 'string') {
                    console.log(err);
                } else {
                    console.warn(`ERROR(code: ${err.code}): ${err.message}`);
                }
            })
            .finally(function() {
                toggleAjaxLoading('branches-leaflet__modal__content__menu__branches-list');
                toggleAjaxLoading(mapHtmlDivID);
            });
    });


    $(document).on('click', '.button-open-branch-update-modal, .change-order-branch-leaflet__close-update-branch-modal', function() {
        var modal = $('.change-order-branch-leaflet__update-modal__container');
        modal.toggleClass('change-order-branch-leaflet__update-modal__container--hidden');
    });

    $(document).on('click', '.button-open-branch-update-modal', function() {
        var newBranchID = $(this).data('branch-id');
        getUpdateTaxDocumentBranchDataPromise(newBranchID)
            .then(function(result){
                updateTaxDocumentBranchModal(result);
            })
            .catch(function (error){
                console.error('Error:', error);
            });
    });
});

function openMap()
{
    if (mapCenterCoordinates === null) {
        setLeafletMapVariablesFromLaravel();
        toggleAjaxLoading('modal-leaflet-map__open-btn');
        var locationPromise = getLocationPromise();
        locationPromise
            .then(function(result) {
                mapCenterCoordinates = result;
                activeMarkerCoords = {lng:mapCenterCoordinates.lng, lat:mapCenterCoordinates.lat};
            })
            .catch(function(err) {
                mapCenterCoordinates = getDefaultMapCenterCoordinates();
                activeMarkerCoords = getDefaultActiveMarkerCoordinates();
            })
            .finally(function()
            {
                toggleAjaxLoading('modal-leaflet-map__open-btn');
                openMapModal();
                resolveMapLoad();
                initAutocomplete();
            });
    } else {
        openMapModal();
    }
}

function openMapModal()
{
    if(isOnBranchPage)
    {
        mapCenterCoordinates = getDefaultMapCenterCoordinates();
        mapCenterCoordinates.zoom = 7;
        activeMarkerCoords = getDefaultActiveMarkerCoordinates();
    }
    else {
        $('html').css('overflow-y','hidden');
    }
    mapModal.style.display = "block";
}

function closeMapModal()
{
    if(!isOnBranchPage) {
        mapModal.style.display = "none";
        $('html').css('overflow-y','scroll');
    }
}

//meni zobrazeni z mobilu na desktop a naopak
function toggleView(triggerAction)
{
    if ($(window).width() < windowWidthSM) {
        if(triggerAction == 'phone-tab__map')
        {
            showMapPhone();
            phoneView = mapView;
            displayMode = getDisplayMode();
        }
        if(triggerAction == 'phone-tab__branches')
        {
            showBranchesPhone();
            phoneView = branchesView;
            displayMode = getDisplayMode();
        }
        if(triggerAction == 'resize'  && displayMode != getDisplayMode())
        {
            if(phoneView == mapView)
            {
                showMapPhone();
            }else{
                showBranchesPhone();
            }

            //pokud se prechazi z desktopu s otevrenym popupem na mobil tak se mapa posune k zarovnane karte (jestli to tak chcem)

            //if(map._popup){
            //    map._popup.update();
            //}
            displayMode = getDisplayMode();
        }
    }
    if ($(window).width() >= 768 && displayMode != getDisplayMode()) {
        showDefaultDesktop();
        displayMode = getDisplayMode();
    }
}

function getDisplayMode()
{
    if ($(window).width() >= windowWidthSM)
    {
        return displayModeDesktop;
    }
    return displayModePhone;
}

function showMapPhone()
{
    if( typeof map !== "undefined" ) {
        var branchesListContainer = $(".branches-leaflet__modal__content__menu__branches-list-container");
        branchesListContainer.css("display","none");

        var mapWrapper = $(".branches-leaflet__modal__content__map-wrapper");
        mapWrapper.css({
            "display":"block",
        });

        var menu = $(".branches-leaflet__modal__content__menu");
        menu.css({'overflow':'initial'}); //bugfix aby autocomplete-js results list neprekryvala mapa

        map.invalidateSize(); //pokud se mapa nacte a je v css display:none, tak se spatne zobrazuje, tohle ji prenacte
    }
}

function showBranchesPhone()
{
    if( typeof map !== "undefined" ) {
        var menu = $(".branches-leaflet__modal__content__menu");
        menu.css({
            "display":"flex",
            'overflow':'hidden',
        });

        var mapWrapper = $(".branches-leaflet__modal__content__map-wrapper");
        if(!isOnBranchPage) {
            mapWrapper.css({"display":"none"});
        }

        var branchesListContainer = $(".branches-leaflet__modal__content__menu__branches-list-container");
        branchesListContainer.css("display","block");
    }
}

function showDefaultDesktop()
{
    var menu = $(".branches-leaflet__modal__content__menu");
    menu.css({
        "display":"flex",
        "overflow":"hidden",
    });

    var mapWrapper = $(".branches-leaflet__modal__content__map-wrapper");
    mapWrapper.css({
        "display":"block",
    });

    var branchesListContainer = $(".branches-leaflet__modal__content__menu__branches-list-container");
    branchesListContainer.css("display","block");
}

function setLeafletMapVariablesFromLaravel()
{
    let leafletMapData = getLeafletMapDataPromise();
    leafletMapData
    .then(function(result){
        apiKey = result.apiKey;
        app_country_id = result.app_country_id;
        allDeliveriesData = result.allDeliveriesData;
        deliveryFilterGroups = result.deliveryFilterGroups;
        activeDeliveryIDs = result.activeDeliveryIDs;
        activeMarkerFilters = result.activeMarkerFilters;
        defaultActiveMarkerCoordinatesFromLaravel = result.defaultActiveMarkerCoordinatesFromLaravel;
        countryDeliveriesData = getCountryDeliveriesData();
        selectedBranchID = getSelectedBranchIDFromLaravel();
        setBranchRedirectUrl = result.setBranchRedirectUrl;
        setBranchRedirectUrl_isOnBranchPage = result.setBranchRedirectUrl_isOnBranchPage;
        taxDocumentID = result.taxDocumentID;
        langTexts = result.langTexts;
        redirectBackToPubUrl = result.redirectBackToPubUrl;
    })
    .catch(function(error){
        console.log('ERROR - getMapVariables', error);
    });
}

function getLeafletMapDataPromise()
{
    var promise = new Promise(function(resolve, reject) {
        var routeUrl =  webBaseUrl + '/api/branches-map/get-map-variables';
        var urlParams = new URLSearchParams(window.location.search);
        var urlParam_taxDocumentID = urlParams.get('taxDocumentID');
        var data = {
            'taxDocumentID': urlParam_taxDocumentID,
        }
        $.ajax({
            url: routeUrl,
            type: 'POST',
            contentType: "application/json; charset=utf-8",
            dataType: 'json',
            async: false,
            data: JSON.stringify(data),

            success: function(result) {
                resolve(result);
            },
            error: function(result) {
                reject(result);
            },
        });
    });

    return promise;
}

function resolveMapLoad() {
    map = createMap();
    mcg = createMarkerClusterGroup();
    map.addLayer(mcg);
    createMarkerSubGroupsTree();
    fillSubGroupsWithMarkers(activeDeliveryIDs);
    createMarkerAtLocation(activeMarkerCoords);

    //zoomovani clusterů pri hoveru (zamerne nezoomuje spiderfied cluster)
    mcg.on('clustermouseover', function (e){
        if(typeof e.target._spiderfied === 'undefined' || e.target._spiderfied === null){
            var clusterIcon = e.layer.options.icon._icon;
            var currentTransformValue = clusterIcon.style.transform;
            var transformValueWithScale = currentTransformValue + ' scale(1.1)';
            clusterIcon.style.transform = transformValueWithScale;
        }
    });

    mcg.on('clustermouseout', function (e){
        var clusterIcon = e.layer.options.icon._icon;
        var currentTransformValue = clusterIcon.style.transform;
        var transformValueWithoutScale = currentTransformValue.replace(/scale\(1\.1\)/, '');
        clusterIcon.style.transform = transformValueWithoutScale;
    });

    //reseni na prenacteni popupu jakmile mam stazeny image pobocky podle https://github.com/Leaflet/Leaflet/issues/5484
    //Bez tohoto listeneru popup nevi jak velky ma byt, protoze se obrazek nacte do pripravene karty az pozdeji.
    //Po nacteni obrazku se popup updatne, cimz se prepocita jeho vyska a spravne se umisti do viewportu tak, aby sel cely spravne videt
    document.querySelector(".leaflet-popup-pane").addEventListener("load", function(event) {
        var tagName = event.target.tagName;
        var lastOpenedPopup = map._popup; // Last open Popup.
        var hasItemPropAttribute = event.target.hasAttribute("itemprop"); //pocitam s tim, ze zadny z obrazku, co se bude cpat do card-popup nebude mit attribute itemProp, jinak to chce lepsi selector
        if (tagName === "IMG" && lastOpenedPopup && hasItemPropAttribute && !lastOpenedPopup._updated) {
            lastOpenedPopup._updated = true;
            lastOpenedPopup.update();
        }
    }, true); // Capture the load event, because it does not bubble.

    //nevim proc nestaci closeOnEscapeKey jen v parametrech pri vytvareni popupu u markeru ve funkci createFilledMarker
    addEventListener("keydown", (event) => {
        if(event.keyCode === 27 && map._popup && map._popup.options.closeOnEscapeKey)
        {
            map.closePopup();
        }
    });

    //jestli klikam v branchesList na pobocky, tak me to presune na dany marker a klikne to na nej, onclick listener musi byt definovany mimo funkci, jinak se deklaruje vicekrat
    var branchesList = $(".branches-leaflet__modal__content__menu__branches-list");
    branchesList.on("click",".branches-leaflet__branch__wrapper", function(e){
        if(getDisplayMode() === displayModeDesktop){
            $('.branches-leaflet__branch__wrapper').removeClass('active');
            $('.branches-leaflet__branch__distance').addClass('hidden');
            $(this).addClass('active');
            var branchWrapper = $(e.target).closest('.branches-leaflet__branch__wrapper');
            var isTargetExcludedElement = $(e.target).is('.branches-leaflet__branch__distance, .branches-leaflet__selected-branch-tag'); //kdyby jich bylo vic, tak je oddelit jen carkou
            if (branchWrapper.length && !isTargetExcludedElement) {
                var markerId = branchWrapper.data('branch-item-marker-id');
                PanToAndClickOnBranchMarker(markerId);
            }
        }
    });

    branchesList.on("mouseenter",".branches-leaflet__branch__wrapper", function(e){
        var target = $(e.target).closest('.branches-leaflet__branch__wrapper');
        if (target.length) {
            hoverOnBranchListItem(target.data('branch-item-marker-id'));
        }
    });

    branchesList.on("mouseleave",".branches-leaflet__branch__wrapper", function(e){
        var target = $(e.target).closest('.branches-leaflet__branch__wrapper');
        if (target.length) {
            hoverOnBranchListItem(target.data('branch-item-marker-id'));
        }
    });
}

function getLocationPromise() {
    var promise = new Promise(function(resolve, reject) {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
                function(position) {
                    resolve({
                        lng: position.coords.longitude,
                        lat: position.coords.latitude,
                        zoom: 17
                    });
                },
                function(err) {
                    if (typeof err === 'string') {
                        console.log(err);
                    } else {
                        console.warn(`ERROR(code: ${err.code}): ${err.message}`);
                    }
                    switch (err.code) {
                        case GEOLOCATION_PERMISSION_DENIED:
                            showNotification('branches-leaflet__notification-geolocation-denied');
                            reject("ERROR - User denied geolocation permission.");
                            break;
                        case GEOLOCATION_POSITION_UNAVAILABLE:
                            showNotification('branches-leaflet__notification-geolocation-unavailable');
                            reject("ERROR - Geolocation position unavailable.");
                            break;
                        case GEOLOCATION_TIMEOUT:
                            showNotification('branches-leaflet__notification-geolocation-timeout');
                            reject("ERROR - Geolocation request timed out.");
                            break;
                        default:
                            reject("ERROR - Geolocation error code: " + err.code + ": " + err.message);
                            break;
                    }
                }, {
                    //enableHighAccuracy: true, //napr s GPS to vrati presnejsi result (taky to trva dyl, coz obcas zpusobi timeout => musel bych v pripade timeoutError s highAcc udelat dalsi promise na location bez highAcc)
                    enableHighAccuracy: false,
                    timeout: 10000, //za 10s to vyhodi GEOLOCATION_TIMEOUT error a v promisu se veme catch vetev: (default coordinates)
                    maximumAge: 0 //nepouziva se cached pozice
                },
            );
        } else {
            showNotification('branches-leaflet__notification-geolocation-unavailable'); //prohlizec neumi geolokaci
        }
    });
    return promise;
};

function PanToAndClickOnBranchMarker(branch_id)
{
    var marker = root.findMarker(branch_id);
    if(typeof marker !== 'undefined'){
        //!nevola event mcg.on('click',
        mcg.zoomToShowLayer(marker, function(){
            marker.fire('click');
        });
    } else {
        throw new Error('pobocka neni aktivni (nenalezena v TreeNode)');
    }
}

//vypise checkboxy k zapniani a vypinani subGroup (pouzite uz jen k debugovani, je poterba odkomentovat v resoleMapLoad() kod s control)
function addControls(node)
{
    control.addOverlay(node.subGroup, '<em>' + node.getNodePath().join(" --- ") + '</em>');
    node.children.forEach(child => addControls(child));
}

function createMap() {
    //pridani podkladove mapy
    let tilesType = 'basic';
    let url = `https://api.mapy.cz/v1/maptiles/${tilesType}/256/{z}/{x}/{y}?apikey=${apiKey}`;

    let seznamMapyTile = L.tileLayer(url, {
        maxZoom: 19,
        minZoom: 7,
        attribution: '© <a href="https://www.seznam.cz/">Seznam.cz</a>'
    });

    //mapy api aerial mapa zvlada v madarsku jen maxZoom 13:
        // https://developer.mapy.com/rest-api-mapy-cz/function/map-tiles/
        // Attention: The aerial map has limited zoom levels. Specifically: the entire world only up to zoom level 13,
        // only the Czech Republic up to 20, Slovakia, Austria, Poland, Slovenia, France, and Switzerland up to 19, Germany (excluding federal states of Baden-Württemberg, Bremen, and Schleswig-Holstein) up to 19.
    let aerialMapMaxZoom;
    switch(app_country_id) {
        case 7: // HU
            aerialMapMaxZoom = 13;
            break;
        case 1: // CZ
        case 2: // SK
            aerialMapMaxZoom = 19;
            break;
        default:
            aerialMapMaxZoom = 13;
    }

    tilesType = 'aerial';
    url = `https://api.mapy.cz/v1/maptiles/${tilesType}/256/{z}/{x}/{y}?apikey=${apiKey}`;
    let seznamMapyAerialTile = L.tileLayer(url, {
        maxZoom: aerialMapMaxZoom,
        minZoom: 7,
    });

    var map = L.map(mapHtmlDivID, {
        center: [mapCenterCoordinates.lat, mapCenterCoordinates.lng],
        zoom: mapCenterCoordinates.zoom,
        layers: [seznamMapyTile , seznamMapyAerialTile]
    });

    seznamMapyTile.addTo(map);
    seznamMapyAerialTile.addTo(map);

    var baseMaps = {
        [langTexts.mapTileBase]: seznamMapyTile,
        [langTexts.mapTileAerial]: seznamMapyAerialTile,
    };

    map.removeLayer(seznamMapyAerialTile);

    L.control.layers(baseMaps, {}).addTo(map); //prida vrstvy do mapy
    //L.control.scale({metric:true,imperial:false}).addTo(map); //meritko
    return map;
}

function createMarkerClusterGroup() {
    var mcg = L.markerClusterGroup({
        chunkedLoading: true,
        iconCreateFunction: function(cluster) {
            var icon = L.divIcon({
                html: '<div class="branches-leaflet__marker-cluster__content"> <b>' + cluster.getChildCount() + '</b> </div>',
                className: 'branches-leaflet__marker-cluster',
                iconSize: [42, 42]
            });

            return icon;
        },
        maxClusterRadius: 80, //A cluster will cover at most this many pixels from its center - default je 80
        showCoverageOnHover: false, //zobrazuje plochu clusteru na mape
        //disableClusteringAtZoom: 18,

        // Set to false to disable all animations (zoom and spiderfy).
        // If false, option animateAddingMarkers below has no effect.
        // If L.DomUtil.TRANSITION is falsy, this option has no effect.
        animate: true,

        //Whether to animate adding markers after adding the MarkerClusterGroup to the map
        // If you are adding individual markers set to true, if adding bulk markers leave false for massive performance gains.
        animateAddingMarkers: false,

        // Setting this to false prevents the removal of any clusters outside of the viewpoint, which
        // is the default behaviour for performance reasons.
        //removeOutsideVisibleBounds: true,

        //Increase to increase the distance away that spiderfied markers appear from the center
        spiderfyDistanceMultiplier: 1,

        // Make it possible to specify a polyline options on a spider leg
        //https://leafletjs.com/reference.html#polyline
        spiderLegPolylineOptions: {
            weight: 0.75,
            color: '#222',
            opacity: 0.5,
            className: 'spiderfied-path-class',
        }
    });

    return mcg;
}

class TreeNode {
    constructor(name, level) {
        this.name = name;
        this.level = level;
        this.subGroup = null;
        this.parentNode = null;
        this.children = [];
        this.markers = [];
        this._isSubGroupAdded = false; //urcuje, zda je jiz subGroup vrstva pridana, aby se pri pristim zavolani znovu nevytvarela duplicitni
        this.layerGroup = null;
    }

    addChild(child) {
        this.children.push(child);
        child.parentNode = this;
    }

    getChildByName(name) {
        return this.children.find(child => child.name === name) || null;
    }

    getNodePath(path = []) {
        if (!this.parentNode) {
            return path.reverse();
        } else {
            path.push(this.name);
            return this.parentNode.getNodePath(path);
        }
    }

    getNodeByPath(path) {
        let currentNode = this;
        for (const nodeName of path) {
            currentNode = currentNode.getChildByName(nodeName);
            if (!currentNode) {
                return null; // Node nenalezen
            }
        }
        return currentNode;
    }

    findMarker(branch_id)
    {
        var marker = this.markers.find(marker => marker.options.branchID === branch_id);
        if (typeof marker !== 'undefined')
        {
            return marker;
        }
        else
        {
            if (this.children.length) {
                return this.children.reduce((result, child) => {
                    // If a marker is found in any child, propagate it up the call stack
                    return result || child.findMarker(branch_id);
                }, undefined);
            } else {
                return undefined;
            }
        }
    }
}

function recursivelyFillNode(parentNode, groupChildren, level) {
    const firstArrayOfChildren = groupChildren[0];
    for (const childrenName of firstArrayOfChildren) {
        const newNode = new TreeNode(childrenName, level);
        parentNode.addChild(newNode);
        if (groupChildren.length > 1) {
            const groupChildrenMinusFirstArray = groupChildren.slice(1);
            recursivelyFillNode(newNode, groupChildrenMinusFirstArray, level + 1);
        }
    }
}

function recursivelyFillSubGroup(node) {
    if (!node.parentNode) {
        node.subGroup = L.featureGroup.subGroup(mcg);
    } else {
        node.subGroup = L.featureGroup.subGroup(node.parentNode.subGroup);
    }

    for (const child of node.children) {
        recursivelyFillSubGroup(child);
    }
}

function toggleSubGroupInTree(node, subGroupName) {
    if (node.children.length) {
        for (const child of node.children) {
            if (child.name === subGroupName) {
                //pred pridanim pres map.addLayer je child.subGroup._map === 'undefined', po map.removeLayer je child.subGroup._map === null:
                if(typeof child.subGroup._map === 'undefined' || child.subGroup._map === null)
                {
                    map.addLayer(child.subGroup);
                } else {
                    map.removeLayer(child.subGroup);
                }
            } else {
                toggleSubGroupInTree(child, subGroupName);
            }
        }
    }
}

function toggleSubGroup(root, subGroupName)
{
    toggleSubGroupInTree(root, subGroupName);

    //!!!leaflet bug - jestlize je jeden marker obsazeny ve dvou subGroupach soucasne je po odstraneni subgroupy z mapy odstranen marker i kdyz by tam mel zustat, protoze je stale obsazeny v druhe aktivni subgroupe
    //bugfix - po togglu subGroupy z mapy je potreba celou nadrazenou vrstvu pro subGroupy odstranit a vratit zpet na mapu, tim se znovu vyhodnoti markery a bugnuty (chybne odstraneny/pridany) marker se opravi
    //https://github.com/ghybs/Leaflet.FeatureGroup.SubGroup/issues/13
    root.children.forEach(deliveryName => {
        if(deliveryName.subGroup._map !== null && deliveryName._areMarkersAdded)
        {
            map.removeLayer(deliveryName.subGroup);
            map.addLayer(deliveryName.subGroup);
        }
    });
}

function createMarkerSubGroupsTree() {
    var deliveryNames = getCountryDeliveryIDs().map(deliveryID => getDeliveryNameById(deliveryID));

    var groupChildren = [
        deliveryNames
    ];

    for(var filterGroupType in deliveryFilterGroups)
    {
        var groupTypeNames = deliveryFilterGroups[filterGroupType].map(obj => obj.type);
        groupChildren.push(groupTypeNames);
    }

    var level = 0;
    root = new TreeNode('root', 0);
    recursivelyFillNode(root, groupChildren, level + 1);
    recursivelyFillSubGroup(root);
    root.children.forEach(child => {
        child._areMarkersAdded = false;
    });
}

//vytahne requestem data o markerech, jestlize markery jeste nejsou pridane v delivery subGroupe (podle parametru _areMarkersAdded)
//vytvori markery a prida je do patricne subGroupy
function fillSubGroupsWithMarkers(deliveryIDs) {
    var deliveryIDsWithoutAddedMarkers = deliveryIDs.filter(deliveryID => {
        var deliveryName = getDeliveryNameById(deliveryID);
        return root.children.some(child => {
            return child.name.includes(deliveryName) && !child._areMarkersAdded;
        });
    });

    if(deliveryIDsWithoutAddedMarkers.length > 0) {
        var branchesPromise = fetchBranchesPromise(deliveryIDsWithoutAddedMarkers);
        branchesPromise
            .then(function(branchesPromiseResult) {
                branchesPromiseResult.branches.forEach(branch => {
                    var deliveryName = getDeliveryNameById(branch.delivery_id);
                    var branchType = null;

                    if(branch.isBox == 1)
                    {
                        branchType = 'box';
                    } else {
                        branchType = 'shop';
                    }

                    var marker = createFilledMarker(branch);
                    var node = root.getNodeByPath([deliveryName,branchType]);
                    node.markers.push(marker);
                });

                deliveryIDsWithoutAddedMarkers.forEach(deliveryID => {
                    var deliveryName = getDeliveryNameById(deliveryID);

                    root.children.forEach(child => {
                        if (child.name.includes(deliveryName) && !child._areMarkersAdded) {
                            child._areMarkersAdded = true;
                        }
                    });
                });

                attachMarkersToSubGroupsAndMap(root);
            });
    }
}

function attachMarkersToSubGroupsAndMap(node)
{
    if(node.markers.length && !node._isSubGroupAdded)
    {
        node.layerGroup = L.layerGroup(node.markers);
        node.subGroup.addLayer(node.layerGroup);
        node._isSubGroupAdded = true;
    }

    var isNodeActiveDelivery = activeDeliveryIDs.some(function(id) {
        return getDeliveryNameById(id) === node.name;
    });

    //prida aktivni subGroupy do mapy (mcg vzdy)
    if((activeMarkerFilters.includes(node.name) || isNodeActiveDelivery || node.name === 'root') && node.subGroup._map !== null){
        node.subGroup.addTo(map);
    }
    node.children.forEach(child => attachMarkersToSubGroupsAndMap(child));
}

function fetchBranchesPromise(deliveryIDs) {
    var promise = new Promise(function(resolve, reject) {
        var baseUrl = webBaseUrl;
        var data = {
            'deliveryIDs': deliveryIDs,
        };

        $.ajax({
            url: baseUrl + "/api/branches-map/fetch-branches",
            type: 'POST',
            contentType: "application/json; charset=utf-8",
            dataType: 'json',
            async: true,
            data: JSON.stringify(data),
            beforeSend: function()
            {
                toggleAjaxLoading(mapHtmlDivID);
            },

            success: function(result) {
                toggleAjaxLoading(mapHtmlDivID);
                resolve(result);
            },
            error: function(result) {
                reject(result);
            },
        });
    });
    return promise;
}

function createFilledMarker(branch) {
    var markerIcon = createMarkerIcon(branch.delivery_id, 'normal');
    var marker = L.marker(
        [branch.latitude, branch.longitude], {
            branchDeliveryID: branch.delivery_id,
            branchID: branch.id,
            icon: markerIcon,
            //title: branch.id, //debugging
        }
    );
    //pripadne neslo by pouze nastylovat my-div-image class:hover v html^ bez eventů?^
    //otazka jak se ma chovat aktivni marker
    marker.on("mouseover", function(e) {
        e.target._icon.classList.add("branches-leaflet__marker-hover");
    });
    marker.on("mouseout", function(e) {
        e.target._icon.classList.remove("branches-leaflet__marker-hover");
    });

    //musi byt async kvuli await 500ms na zavreni filtru pres jsToggle animaci
    marker.on('click', async function(e){
        //pokud jsou otevrene filtry na mensim telefonu a klikne se na marker, tak s mapou nejde pak hybat, protoze ji celou zablokuje popupCard => zavrit filtry (cekat 500ms na jsToggle animaci, pak map.invalidateSize())
        var areFiltersOpen = $('.branches-leaflet__modal__checkboxes-wrapper__deliveries').is(':visible');
        if(areFiltersOpen && ($(window).width() < windowWidthSM))  {
            var button = $('.branches-leaflet__modal__checkboxes__filters-toggle-button:visible');
            button.click();
            await new Promise(resolve => setTimeout(resolve, 500));
            map.invalidateSize();
        }

        //zmena icony u prave zvoleneho markeru, navraceni default icony u markeru, ktery prestal byt prave zvoleny
        if(activeBranchID !== null){
            var activeMarkerBeforeClick = root.findMarker(activeBranchID);
            activeMarkerBeforeClick.setIcon(createMarkerIcon(activeMarkerBeforeClick.options.branchDeliveryID, 'normal'));
        }
        marker.setIcon(createMarkerIcon(e.target.options.branchDeliveryID,'active'));

        if(typeof e.target._popup === 'undefined'){
            //vytvoreni popup:
            getBranchDetailsPromise(e.target.options.branchID)
            .then(function (branchDetails) {
                bindPopupToMarkerAndOpen(branchDetails,e.target);
            })
            .catch(function (error) {
                console.error('Error:', error);
            });
        }

        //spiderfied markery maji posunute souradnice markeru na mape
        if(typeof marker._preSpiderfyLatlng !== 'undefined') {
            activeMarkerCoords = {lng:marker._preSpiderfyLatlng.lng, lat:marker._preSpiderfyLatlng.lat};
        } else{
            activeMarkerCoords = {lng:marker._latlng.lng, lat:marker._latlng.lat};
        }
        activeBranchID = marker.options.branchID;

        if(e.originalEvent != undefined) {
            updateBranchesList(activeMarkerCoords, false);
            $('.branches-leaflet__branch__distance').removeClass('hidden');
        }
    });

    marker.on('popupopen', function (e) {
        toggleMarkerActive(e.target._icon);
    });

    marker.on('popupclose', function (e) {
        if(e.target._icon !== null){
            toggleMarkerActive(e.target._icon);
        }
    });
    return marker;
}


function createMarkerIcon(branchDeliveryID, state)
{
    var iconHtml;
    switch (state) {
        case 'normal':
            iconHtml = '<img class="my-div-image" src="' + getDeliveryImageUrl(branchDeliveryID, deliveryImageMarker) + '" />';
            break;
        case 'active':
            iconHtml = '<img class="my-div-image marker-active" src="' + getDeliveryImageUrl(branchDeliveryID, deliveryImageMarker) + '" />';
            break;
        default:
            iconHtml = '<img class="my-div-image" src="' + getDeliveryImageUrl(branchDeliveryID, deliveryImageMarker) + '" />';
            break;
    }

    var icon = new L.DivIcon({
        className: 'my-div-icon',
        html: iconHtml,
        popupAnchor: [0,-40],
        iconAnchor:[13,40],
        //iconAnchor: [12,30], //posune ikonu  //[12,30] == [margin-left:-12px,margin-right:-30px] (ikona pak ale nesedi pri spiderfy stavu)
        iconSize: [28,40],
    });
    return icon;
}

function hoverOnBranchListItem(branchID)
{
    var marker = getUnclusteredMarkerInView(branchID);
    if (marker != null)
    {
        toggleMarkerActive(marker._icon);
    }
}

function getUnclusteredMarkerInView(branchID) {
    var foundMarker = null;
    map.eachLayer( function(layer) {
        if(
            layer instanceof L.Marker
            && layer.options.branchID == branchID
        ) {
            foundMarker = layer;
            return;
        }
    });
    return foundMarker;
}

//markerActive nebo markerHover?, prejmenovat podle funkcionality
function toggleMarkerActive(markerIcon)
{
    //markerIcon.classList.toggle('marker-active');
    markerIcon.classList.toggle('branches-leaflet__marker-hover');
    //nedela to scale animaci, protoze ta je v css definovana na my-div-image:hover
}

function getBranchDetailsPromise(id) {
    var baseUrl = webBaseUrl;
    var data = {
        'branch_id': id
    };

    return new Promise(function (resolve, reject) {
        $.ajax({
        url: baseUrl + "/api/branches-map/selected-branch",
        type: 'POST',
        contentType: "application/json; charset=utf-8",
        dataType: 'json',
        async: true,
        data: JSON.stringify(data),

        success: function (result) {
            resolve(result.branch);
        },
        error: function (result) {
            console.log('ERROR async selected-branch:', result);
            reject(result);
        }
        });
    });
}

function bindPopupToMarkerAndOpen(branchDetails,marker)
{
    var detailContent = getBranchDetailPopupContent(branchDetails);
    let popup = L.popup({
                minWidth: 300,
                maxWidth: 300,
                autoPanPadding: [8, 8],
                closeButton: false,
                //closeOnClick: false, //kdyz kliknu vedle tak se nema zavrit
                closeOnEscapeKey: true,
                className: 'gigaprint-leaflet-popup',
            })
            .setContent(detailContent.prop("outerHTML"));
    marker.bindPopup(popup);
    marker.openPopup(); //jestlize uz je marker popup nastaveny, tak se otevira automaticky po marker.click nekde jinde v dalsich propagated eventech
}

function getDeliveryImageUrl(delivery_id, imageType) {
    var delivery = countryDeliveriesData.find(delivery => delivery.id === delivery_id);
    if (delivery) {
        switch (imageType) {
            case deliveryImageMarker:
                return delivery.markerImageUrl;
                break;
            case deliveryImageIcon:
                return delivery.iconImageUrl;
                break;
            case deliveryImageLogo:
                return delivery.logoImageUrl;
                break;
            default:
                return "";
                break;
        }

    }
    return "";
}

function getBranchDetailPopupContent(branchDetails) {
    var popupCard = $("<div>", {
        "class": `branches-leaflet__popup-card`,
    });

    var popupCardInnerHtmlStructure =
        `
        <div class="branches-leaflet__popup-card__header"></div>
        <div class="branches-leaflet__popup-card__body small-scrollbar scroll-blur"></div>
        <div class="branches-leaflet__popup-card__footer"></div>
        `;

    //local branch zobrazovana vyjimka
    var noticeMessage = branchDetails.noticeMessage
        ? `
            <br>
            <strong class="color-negative-80">
                <span class="icon--info-circle mr-4"></span>
                ${branchDetails.noticeMessage}
            </strong>
        `
        : '';

    popupCard.append(popupCardInnerHtmlStructure);

    if (branchDetails == null) {
        popupCard.find('branches-leaflet__popup-card__body').html(`${langTexts.branchPopupCardMissingDataError}`);
        return popupCard;
    }

    popupCard.find('.branches-leaflet__popup-card__header').html(
        `
        <div class="branches-leaflet__popup-card__header__delivery-logo">
            <img src="${getDeliveryImageUrl(branchDetails.delivery_id, deliveryImageLogo)}"/>
        </div>
        <div class="branches-leaflet__popup-card__header__close-btn">
            <span class="icon--close-medium"></span>
        </div>
        `
    );

    popupCard.find('.branches-leaflet__popup-card__body').html(
        `
        <div class="branches-leaflet__popup-card__body__details__branch-info">
            ${branchDetails.HTMLImage !== ''
                ? `
                    <div class="branches-leaflet__popup-card__body__details__image">
                        ${branchDetails.HTMLImage}
                    </div>
                `
                : ''
            }
            <div class="branches-leaflet__popup-card__body__details__text">
                <strong>${branchDetails.frontendName}</strong>
                <br>
                ${branchDetails.contact.street} ${branchDetails.contact.house_number}, ${branchDetails.contact.city}
            </div>
        </div>

        <hr class="mt-8 mb-8 clear">
        <div class="branches-leaflet__popup-card__body__details__opening-hours">
            <strong>${langTexts.openingHours}</strong>
            <br>
            ${branchDetails.openingHours}
            ${noticeMessage}
        </div>

        <hr class="mt-8 mb-8">
        <div class="branches-leaflet__popup-card__body__details__opening-hours">
            <strong>${langTexts.paymentMethods}</strong>
            <br>
            ${getPaymentInfoContent(branchDetails.payment_card_in_app, branchDetails.payment_card_onsite, branchDetails.payment_cash)}
        </div>
        <div class="mt-8">${branchDetails.directions != null && branchDetails.directions}</div>
        `
    );
    popupCard.find('.branches-leaflet__popup-card__footer').html(``);
    if(taxDocumentID){
        var button_openBranchUpdateModal = createOpenBranchUpdateModal(branchDetails);
        popupCard.find('.branches-leaflet__popup-card__footer').append(button_openBranchUpdateModal);

    } else {
        var selectionForm = createBranchSelectionForm(branchDetails);
        if(isOnBranchPage) {
            var buttonWraper = $(`<div>`, {
                "style": "display: flex; justify-content: center; align-items: center;",
            });
            var infoTooltip =
            `<div class="form__group__hint-group" style="width: auto;">
                <div class="branch__card__detail-info__content">
                    <div
                        class="form__group__hint-group__hint branch__card__detail-info"
                        data-js-tooltip="${langTexts.isOnBranchPage.setBranchTooltip}"
                    >
                        <span class="icon--info-circle"></span>
                    </div>
                </div>
            </div>`;

            buttonWraper.html(selectionForm);
            popupCard.find('.branches-leaflet__popup-card__footer').append(buttonWraper);
            popupCard.find('.branches-leaflet__popup-card__footer')
            .prepend(
                `<div style="display:flex; align-items:center; margin-bottom:4px;">
                    <div>${langTexts.isOnBranchPage.setBranchLabel}</div>
                    ${infoTooltip}
                </div>`
            );
        }
        else {
            popupCard.find('.branches-leaflet__popup-card__footer').append(selectionForm)
        }
    }

    return popupCard;
}

function getPaymentInfoContent(payment_card_in_app, payment_card_onsite, payment_cash){
    var paymentString = '';

    //PPL:
        //alza_box: pouze predem online (PIN prijde do mailu, prijde SMS, nebo lze najit v aplikaci ppl)
        //ppl_box: platba kartou, platba predem online  (po zadani pinu se otevre, neni potreba aplikace)
        //ppl_shop: platba hotove, platba kartou, platba predem online
    //BALIKOVNA:
        //box: jen predem online (Platba pouze předem kartou online)
        //depo/pobočka: predem online, cash, karta na miste
        //partner: predem online, cash
    //ZASILKOVNA
        //box: jen predem online
        //shop: kartou na miste ,hotove,predem online
    //GIGAPRINT
        //v trenčíně: jen hotově
        //v jinych: hotově, kartou na miste
    //BALIK NA POSTU
        //pošta: hotově, kartou na miste

    if(payment_card_onsite){
        paymentString = paymentString +
        `<div class="branches-leaflet__popup-card__body__payment-info">
            ${langTexts.payment_card_onsite} <span class="color-positive-100 icon--check icon--bold"></span>
        </div>`;
    }

    if(payment_card_in_app){
        paymentString = paymentString +
        `<div class="branches-leaflet__popup-card__body__payment-info">
            ${langTexts.payment_card_in_app} <span class="color-positive-100 icon--check icon--bold"></span>
        </div>`;
    }

    if(payment_cash){
        paymentString = paymentString +
        `<div class="branches-leaflet__popup-card__body__payment-info">
            ${langTexts.payment_cash} <span class="color-positive-100 icon--check icon--bold"></span>
        </div>`;
    }

    return paymentString;
}

function createBranchSelectionForm(branch)
{
    if(isOnBranchPage)
    {
        var urlWithParams = setBranchRedirectUrl_isOnBranchPage;
        var selectBranchForm = $(`<form>`, {
            "method": "POST",
            "action": setBranchRouteUrl,
            "style": "width: -webkit-fill-available;",
        });
    }
    else {
        var urlWithParams = setBranchRedirectUrl;
        var cityUrlPart = '';
        var localityUrlPart = '';

        if (branch.contact.hasOwnProperty('city') && branch.contact.city !== null) {
            var cityUrlPart = branch.contact.city;
        }

        if (branch.contact.hasOwnProperty('sublocality') && branch.contact.sublocality !== null) {
            var localityUrlPart = branch.contact.sublocality;
        }
        urlWithParams = urlWithParams.replace('cityUrlPart', cityUrlPart);
        urlWithParams = urlWithParams.replace('localityUrlPart', localityUrlPart) + '#basket-branches';

        var ajaxParts = [
            'component-Order-Basket-1',
            'component-Order-Deliveries-1',
            'component-Order-Payments-1',
            'component-Order-Contacts-1',
            'component-Order-Recap-1',
            'component-Order-BasketSummary-1',
        ];
        var selectBranchForm = $(`<form>`, {
            "method": "POST",
            "action": setBranchRouteUrl,
            "class": "ajax",
            "style": "width: -webkit-fill-available;",
            "ajaxparts": ajaxParts.join(' '),
            "ajaxtargets": ajaxParts.join(' '),
        });
    }

    selectBranchForm.html(
        `
            <input type="hidden" name="branch" value="${branch.id}">
            <input type="hidden" name="redirect_route" value="${urlWithParams}">
            <button target='_blank' class='btn-outline--primary full-width btn--sm'>
                ${langTexts.selectBranchFormButtonText}
            </button>
        `
    );

    selectBranchForm.attr('data-branch-id', branch.id);

    return selectBranchForm;
}

function createOpenBranchUpdateModal(branch){
    var button_openBranchUpdateModal = $(`<button>`, {
        "class": "button-open-branch-update-modal btn-outline--primary full-width btn--sm",
    });
    button_openBranchUpdateModal.attr('data-branch-id', branch.id);
    button_openBranchUpdateModal.html(`${langTexts.changeSelectedBranchInPubButtonText}`);
    return button_openBranchUpdateModal;
}

function closeCard() {
    map.closePopup(); //zavira vsechny popupy
}

function getDeliveryNameById(id) {
    //buttony vraci string a ne int
    if (!isNaN(id)) {
        id = parseInt(id);
    }

    var delivery = countryDeliveriesData.find(delivery => delivery.id === id);
    if (delivery) {
        return delivery.deliveryName;
    }
    return "";
}

function addActiveDeliveryID(deliveryID)
{
    if(!activeDeliveryIDs.includes(deliveryID))
    {
        activeDeliveryIDs.push(deliveryID);
    }
}

function removeActiveDeliveryID(deliveryID)
{
    var index = activeDeliveryIDs.indexOf(deliveryID);

    if (index !== -1) {
        activeDeliveryIDs.splice(index, 1);
    }
}

function addActiveMarkerFilter(filter)
{
    if(!activeMarkerFilters.includes(filter))
    {
        activeMarkerFilters.push(filter);
    }
}

function removeActiveMarkerFilter(filter)
{
    var index = activeMarkerFilters.indexOf(filter);

    if (index !== -1) {
        activeMarkerFilters.splice(index, 1);
    }
}

function getCountryDeliveriesData()
{
    var deliveryDataHandler = {
        priceValue: 0,

        get price() {
            return this.priceValue;
        },

        set price(newPriceValue) {
            this.priceValue = newPriceValue;
            updateDeliveryPricesInBranchListItems(this.id, newPriceValue);
            updateDeliveryPricesInCheckboxes(this.id, newPriceValue);
        }
    };

    let deliveryObjects = allDeliveriesData.map((delivery) => {
        let newDeliveryDataHandler = Object.create(deliveryDataHandler);
        Object.assign(newDeliveryDataHandler, delivery); // Kopiruje data z puvodniho delivery objektu (vznika z jsonu z laravelu) do deliveryDataHandler objektu
        newDeliveryDataHandler.price = getDeliveryPriceFromLeafletToggleButton(delivery.id);
        return newDeliveryDataHandler;
    });

    return deliveryObjects;
}

function getDeliveryPriceFromLeafletToggleButton(delivery_id)
{
    var attributeSelector = 'data-td-basket-delivery-price-id-' + delivery_id;
    var deliveryPrice = $('#modal-leaflet-map__open-btn').attr(attributeSelector);
    return deliveryPrice;
}

function updateDeliveryPricesInBranchListItems(deliveryId, newPriceValue)
{
    var branchListItems = $('div[data-branch-item-delivery-id]');
    branchListItems.each(function() {
        var branchListDeliveryId = $(this).data('branch-item-delivery-id');
        if(branchListDeliveryId === deliveryId){
            $(this).find('.branches-leaflet__branch__price strong.color-primary-80').text(newPriceValue);
        }
    });
}

function updateDeliveryPricesInCheckboxes(deliveryId, newPriceValue)
{
    var deliveryCheckboxes = $('.branches-leaflet__modal__checkboxes-wrapper--desktop .branches-leaflet__modal__checkboxes-wrapper__deliveries button, .branches-leaflet__modal__checkboxes-wrapper--phone .branches-leaflet__modal__checkboxes-wrapper__deliveries button');
    deliveryCheckboxes.each(function() {
        var button = $(this);
        if (button.val() == deliveryId) {
            button.find('strong.branches-leaflet__modal__content__menu__checkbox__price').text(newPriceValue);
        }
    });
}

function getDefaultMapCenterCoordinates()
{
    var defaultCoordinates = null;
    switch(app_country_id)
    {
        case 1: //CZ
            defaultCoordinates = {lng: 15.842146, lat: 49.802545, zoom: 7};
            break;
        case 2: //SK
            defaultCoordinates = {lng: 19.6306017, lat: 48.7660714, zoom: 7};
            break;
        case 7: //HU
            defaultCoordinates = {lng: 19.0116322, lat: 47.1889619, zoom: 7};
            break;
        default: //CZ
            defaultCoordinates = {lng: 15.1179672, lat: 49.8387944, zoom: 7};
    }
    return defaultCoordinates;
}

function getDefaultActiveMarkerCoordinates(){
    var defaultActiveMarkerCoordinates = defaultActiveMarkerCoordinatesFromLaravel;
    return {lat:defaultActiveMarkerCoordinates.latitude, lng:defaultActiveMarkerCoordinates.longitude};
}

function getCountryDeliveryIDs()
{
    return countryDeliveriesData.map(delivery => delivery.id);
}

function handleCheckboxClick(event) {
    var checkbox = event.currentTarget;
    var checkboxValue = checkbox.getAttribute("value");
    var checkboxesPhone = $('.branches-leaflet__modal__checkboxes-wrapper--phone button');
    var checkboxesDesktop = $('.branches-leaflet__modal__checkboxes-wrapper--desktop button');
    toggleCheckboxes(checkboxValue, checkboxesDesktop);
    toggleCheckboxes(checkboxValue, checkboxesPhone);
    if (!isNaN(checkboxValue))
    {
        var deliveryID = parseInt(checkboxValue);
        activeDeliveryIDs.includes(deliveryID) ? removeActiveDeliveryID(deliveryID) : addActiveDeliveryID(deliveryID);
        //jestlize nemam jeste stazene markery pro danou deliveryID, tak musim:
        //synchronne pockat nez se to stahne, naplni se array s markery, prida se do subGroupy a teprve pak je muzu togglovat
        fillSubGroupsWithMarkers([deliveryID]);
        toggleSubGroup(root, getDeliveryNameById(deliveryID));
    } else {
        activeMarkerFilters.includes(checkboxValue) ? removeActiveMarkerFilter(checkboxValue) : addActiveMarkerFilter(checkboxValue);
        toggleSubGroup(root, checkboxValue);
    }
    updateBranchesList(activeMarkerCoords, false);
}

function toggleCheckboxes(checkboxValue, checkboxesArray)
{
    $.each(checkboxesArray, function(key, checkbox) {
        if(checkbox.getAttribute("value") == checkboxValue)
        {
            checkbox.classList.toggle('sel');
            return false;
        }
    });
}

/**
* Updatuje seznam pobocek
* @param {object} activeMarkerCoords - object latlng, např: {lng:10, lat:10};
* @param {bool}   appendListItems - urcuje, zda se ma pole pobocek branchesInArea premazat nebo k soucasnemu poli pridat dalsi pobocky
*/
function updateBranchesList(activeMarkerCoords, appendListItems)
{
    var promise = getBranchesInAreaPromise(activeMarkerCoords.lng, activeMarkerCoords.lat, appendListItems);
    promise
    .then(function(result) {
            isNearGigaprintBranchAsFirstResult = result.isNearGigaprintBranchAsFirstResult
            if(appendListItems){
                branchesInArea = branchesInArea.concat(result.branches);
                updateBranchesListHtml(result.branches, appendListItems);
            }else{
                branchesInArea = result.branches;
                updateBranchesListHtml(branchesInArea, appendListItems);
            }
            remainingBranches = result.remainingBranches;
        })
        .catch(function(err) {
            if(typeof err === 'string')
            {
                console.log(err);
            }else {
                console.warn(`ERROR(code: ${err.code}): ${err.message}`);
            }
        });
}

/**
* Ziska z DB informace o pobockach v okoli
* @param {bool}     appendListItems - urcuje, zda se ma pole pobocek branchesInArea premazat nebo k soucasnemu poli pridat dalsi pobocky
*/
function getBranchesInAreaPromise(longitude, latitude, appendListItems) {
    if (appendListItems === false) {
        isNearGigaprintBranchAsFirstResult = false;
    }
    var promise = new Promise(function (resolve, reject) {
        var baseUrl = webBaseUrl;
        var data = {
            'pointLatitude': latitude,
            'pointLongitude': longitude,
            'activeDeliveryIDs': activeDeliveryIDs,
            'activeMarkerFilters': activeMarkerFilters,
            'oldBranchIDs': appendListItems ? branchesInArea.map(branch => branch.id) : [],
            'isNearGigaprintBranchAsFirstResult': isNearGigaprintBranchAsFirstResult,
        };

        $.ajax({
            url: baseUrl + "/api/branches-map/get-branches-in-area",
            type: 'POST',
            contentType: "application/json; charset=utf-8",
            dataType: 'json',
            async: true,
            data: JSON.stringify(data),
            beforeSend: function () {
                toggleAjaxLoading('branches-leaflet__modal__content__menu__branches-list');
            },
            success: function (result) {
                toggleAjaxLoading('branches-leaflet__modal__content__menu__branches-list');
                resolve(result);
            },
            error: function (result) {
                console.log('ERROR: - api/branches-map/get-branches-in-area:', result);
                reject(result);
            }
        });
    });

    return promise;
}

function updateBranchesListHtml(branches, appendListItems)
{
    var branchesList = $(".branches-leaflet__modal__content__menu__branches-list");
    var htmlContent = "";

    if(branches.length > 0){
        branches.forEach((branch) => {
            htmlContent += createBranchListItem(branch).prop("outerHTML");
        });
        if(appendListItems)
        {
            branchesList.append(htmlContent);
        }else {
            branchesList.empty().html(htmlContent);
            branchesList.scrollTop(0);
        }
    } else {
        updateBranchesList_null();
    }
}

function createBranchListItem(branch)
{
    var deliveryData = countryDeliveriesData.find((delivery) => delivery.id === branch.delivery_id);
    var listItemContent =
    `

    <div class="branches-leaflet__branch__inline-flex">

        <div class="branches-leaflet__branch__title">
            <img src="${getDeliveryImageUrl(branch.delivery_id, deliveryImageIcon)}"/ class="branches-leaflet__branch__logo">
            <span class="branches-leaflet__branch__label">${branch.frontendName}</span>
        </div>

        ${(branch.id !== activeBranchID)
            ?
            `
            <div
                class="branches-leaflet__branch__distance max-content tag--sm tag-outline--primary"
                data-js-tooltip="${langTexts.distanceFromCurrentlySelectedBranchTooltip}"
            >
                <span class="icon--direction"></span> ${branch.distance <1 ? `${Math.round(branch.distance*1000)} m` : `${Math.round(branch.distance * 10) / 10} km`}
            </div>
            `
            :
            ''
        }
    </div>

    <div class="branches-leaflet__branch__inline-flex">
        <div class="branches-leaflet__branch__address">
            ${branch.contact.street} ${branch.contact.house_number}, ${branch.contact.city}
        </div>
        <div class="branches-leaflet__branch__availability-wrapper branches-leaflet__branch__selected-branch-tag-container">
            <span class="branches-leaflet__branch__availability">${branch.availability}</span>
            ${((selectedBranchID !== null) && (selectedBranchID === branch.id)) ? `${createSelectedBranchTag()}` : ''}
        </div>
    </div>
    <div class="branches-leaflet__branch__buttons">
        <div class="branches-leaflet__branch__inline-flex">
            <div class="branches-leaflet__branch__price">
                <strong class="color-primary-80 size-14">${deliveryData.price}</strong>
            </div>
            <div>
                <div class="branches-leaflet__branch__show-branch-on-phone-btn-wrapper">
                    <a class="btn-text--primary btn-text--sm fit-content">
                        <span class="icon--map-pin size-12"></span> ${langTexts.showBranchOnMap}
                    </a>
                </div>
                <a class="branches-leaflet__branch__show-detail-btn btn-text--primary btn-text--sm fit-content">
                    <span class="icon--chevron-down-small size-8 pl-4"></span> ${langTexts.showBranchDetail}
                </a>
            </div>
        </div>

        <div class="branches-leaflet__branch__details__wrapper">
            <div class="branches-leaflet__branch__details__branch-info">
                ${branch.HTMLImage !== ''
                    ? `
                        <div class="branches-leaflet__branch__details__photo">
                            ${branch.HTMLImage}
                        </div>
                    `
                    : ''
                }
                <div class="branches-leaflet__branch__details__text">
                    <strong>${branch.label}</strong>
                    <br>
                    ${branch.contact.company}
                    ${branch.directions}
                </div>
            </div>

            <hr class="branches-leaflet__modal__content__divider">

            <div class="branches-leaflet__branch__details__opening-hours">
                <strong>${langTexts.openingHours}</strong>
                <br>
                ${branch.openingHours}
            </div>

            <hr class="branches-leaflet__modal__content__divider">
            <div class="branches-leaflet__branch__details__opening-hours">
                <strong>${langTexts.paymentMethods}</strong>
                <br>
                ${getPaymentInfoContent(branch.payment_card_in_app, branch.payment_card_onsite, branch.payment_cash)}
            </div>

        </div>

        <div class="branches-leaflet__branch__details__submit-form-wrapper">
        </div>
    </div>
    `;

    var branchListItem = $("<div>", {
        "class": `branches-leaflet__branch__wrapper ${branch.id === activeBranchID ? 'active' : ''}`,
        "data-branch-item-marker-id":branch.id,
        "data-branch-item-delivery-id":branch.delivery_id,
    });

    branchListItem.append(listItemContent);
    if(!taxDocumentID){
        var branchSelectionForm = createBranchSelectionForm(branch);
        branchListItem.find('.branches-leaflet__branch__details__submit-form-wrapper').append(branchSelectionForm);
    }
    return branchListItem;
}

function toggleBranchItemDetails(showDetailBtn)
{
    var branchListItemWrapper = showDetailBtn.closest('.branches-leaflet__branch__wrapper');
    var detailsWrapper = branchListItemWrapper.find('.branches-leaflet__branch__details__wrapper');
    showDetailBtn.html(function (indexOfText, html) {
        return html.includes(`${langTexts.showBranchDetail}`) ?
            `<span class="icon--chevron-up-small icon--bold size-8 pl-4"></span> ${langTexts.hideBranchDetail}` :
            `<span class="icon--chevron-down-small icon--bold size-8 pl-4"></span> ${langTexts.showBranchDetail}`;
    });

    detailsWrapper.toggleClass('branches-leaflet__branch__details__wrapper--showPhone');
}

function updateBranchListItemSelectedBranch()
{
    var branchListItems = $('div[data-branch-item-marker-id]');
    branchListItems.each(function() {
        var branchItemMarkerId = $(this).data('branch-item-marker-id');
        var selectedBranchTag = $(this).find('.branches-leaflet__selected-branch-tag');
        selectedBranchTag.remove();
        var selectedBranchTagContainer = $(this).find('.branches-leaflet__branch__selected-branch-tag-container');
        if(branchItemMarkerId === selectedBranchID){
            createSelectedBranchTag(selectedBranchTagContainer);
        }
    });
}

/**
* Vytvaří selected-branch-tag
* @param {object} divToBeAppended - div kterému se appenduje selected tag
*/
function createSelectedBranchTag(divToBeAppended = null)
{
    var divHtml =
    `
    <div class="branches-leaflet__selected-branch-tag" data-js-tooltip="${langTexts.branchSelectedTooltip}">
        <div class="branches-leaflet__selected-branch-tag__checkmark"></div>
            ${langTexts.branchSelected}
        </div>
    </div>
    `
    ;

    if(divToBeAppended !== null){
        divToBeAppended.append(divHtml);
    }
    return divHtml;
}

function updateDeliveriesDataPrices()
{
    var openMapButton = $('#modal-leaflet-map__open-btn');
    var dataAttributes = openMapButton.data();
    $.each(dataAttributes, function(key, priceString) {
        if (key.startsWith('tdBasketDeliveryPriceId')) {
            var id_string = key.replace('tdBasketDeliveryPriceId-', '');
            var deliveryId = parseInt(id_string);
            var matchingDelivery = countryDeliveriesData.find(delivery => delivery.id === deliveryId);

            if (matchingDelivery && matchingDelivery.price !== priceString) {
                matchingDelivery.price = priceString;
            }
        }
    });
}

function getUpdateTaxDocumentBranchDataPromise(branch_id){
    var data = {
        'taxDocumentID': taxDocumentID,
        'branchID': branch_id,
    };
    return new Promise(function (resolve, reject) {
        $.ajax({
        url: webBaseUrl + "/api/branches-map/get-order-branches-data",
        type: 'POST',
        contentType: "application/json; charset=utf-8",
        dataType: 'json',
        async: true,
        data: JSON.stringify(data),

        success: function (result) {
            resolve(result);
        },
        error: function (result) {
            console.log('ERROR async get-order-branches-data:', result);
            reject(result);
        }
        });
    });
}

//jedna se o zmenu dopravy v pubu, preklad do madarstiny si stejne udelaji pres prohlizec.
function updateTaxDocumentBranchModal(promiseResult)
{
    var orderBranchChangeSubmitFormWrapper = $('.change-order-branch-leaflet__submit-form-wrapper');
    orderBranchChangeSubmitFormWrapper.html(``);

    var changeOrderBranchForm = $(`<form>`, {
            "method": "POST",
            "action": webBaseUrl + '/api/branches-map/change-order-branch',
        });

    changeOrderBranchForm.html(
        `
            <h3>Objednávka číslo: ${promiseResult.taxDocument.object_id} (id:${promiseResult.taxDocument.id})</h3>
            ${(promiseResult.oldBranch.hasOldBranch)
                ?
                `
                <div class="change-order-branch-leaflet__branch-info-wrapper">
                    <h4 class="mt-0"><span class="icon--map-pin"></span> Původní pobočka</h4>
                    <span class="color-gray-100">Dopravce:</span> ${promiseResult.oldBranch.delivery_name} <br>
                    <span class="color-gray-100">Název pobočky:</span> ${promiseResult.oldBranch.label}
                </div>
                `
                :
                `
                <div class="change-order-branch-leaflet__branch-info-wrapper">
                    <h4 class="mt-0"><span class="icon--map-pin"></span> Původní pobočka</h4>
                    <span class="color-gray-100">Dopravce:</span> ${promiseResult.oldBranch.delivery_name} <br>
                    <span class="color-gray-100">Název pobočky:</span> <span class="color-warning-80 size-18">Objednávka nemá momentálně zvolenou pobočku k odběru.</span>
                </div>
                `
            }

            <div class="change-order-branch-leaflet__branch-info-wrapper">
                <h4 class="mt-0"><span class="icon--map-pin"></span> Nová pobočka</h4>
                <span class="color-gray-100">Dopravce:</span> ${promiseResult.newBranch.delivery_name} <br>
                <span class="color-gray-100">Název pobočky:</span> ${promiseResult.newBranch.label}
            </div>

            <input type="hidden" name="taxDocumentID" value="${promiseResult.taxDocument.id}"/>
            <input type="hidden" name="newBranchID" value="${promiseResult.newBranch.id}"/>
            <input type="hidden" name="newDeliveryID" value="${promiseResult.newBranch.delivery_id}"/>
            <input type="hidden" name="redirectBackToPubUrl" value="${redirectBackToPubUrl}"/>
            <input type="submit" class='btn-outline--primary full-width btn--sm' value=" Změnit pobočku v objednávce"/>
            <span class="icon--info-circle"></span> <span class="color-gray-80 size-12">Kliknutím na tlačítko potvrdíte změnu pobočky a vrátite se zpět k editaci objednávky</span>
        `
    );
    orderBranchChangeSubmitFormWrapper.html(changeOrderBranchForm);
}

function getSelectedBranchIDFromLaravel()
{
    var openMapButton = $('#modal-leaflet-map__open-btn');
    var _selectedBranchID = openMapButton.data("td-basket-selected-branch-id");
    return _selectedBranchID;
}

function showBranchOnMobileMap(branch_id)
{
    //!!!musi jit v poradi:
    //nejdriv se musi scrollnout branchesList, protoze po $('#phone-tab__map').click(); je branchesList display:none
    //pak prepnout na showMapPhone() - tim se odkryje map-wrapper div z display:none;, pak lze na mape najizdet na marker
    var branchesList = $(".branches-leaflet__modal__content__menu__branches-list"); //nevim proc musim volat scrollTop(0) znova, kdyz se vola uz uvnitr updateBranchesListHtml
    branchesList.scrollTop(0);
    $('#phone-tab__map').click();
    PanToAndClickOnBranchMarker(branch_id);
}

function updateBranchesList_null()
{
    var branchesList = $(".branches-leaflet__modal__content__menu__branches-list");
    var htmlContent = "";

    if(isAtLeastOneCheckboxSelected() && activeMarkerCoords === null){
        var htmlContent =
        `
        <strong>Vyhledejte pobočku</strong>
        <img class="empty-basket__picture empty-basket__picture--desktop" src="/obr/errors/empty-basket--desktop.svg" alt="${langTexts.emptyBasket}">
        <img class="empty-basket__picture empty-basket__picture--phone" src="/obr/errors/empty-basket--phone.svg" alt="${langTexts.emptyBasket}">
        `;
    } else {
        var htmlContent =
        `
        <strong>${langTexts.chooseBranchType}</strong>
        `;
    }

    branchesList.empty().html(htmlContent);
    branchesList.scrollTop(0);
}

function loadMoreBranchesInList()
{
    if(remainingBranches > 0) updateBranchesList(activeMarkerCoords, true);
}

function isAtLeastOneCheckboxSelected()
{
    checkboxes = document.querySelectorAll(".branches-leaflet__modal__content__menu__checkbox");
    return Array.from(checkboxes).some(function(checkbox) {
        return checkbox.classList.contains('sel');
    });
}

function createMarkerAtLocation(markerCoordinates, searchPhrase = null)
{
    activeMarkerCoords = {lng:markerCoordinates.lng, lat:markerCoordinates.lat};
    removePositionMarker();
    placePositionMarker(markerCoordinates, searchPhrase);
    updateBranchesList(markerCoordinates, false);
}

function placePositionMarker(markerCoordinates, searchPhrase = null)
{
    var marker = L.marker(
        [markerCoordinates.lat, markerCoordinates.lng], {
            icon: new L.DivIcon({
                //branchID: branch.id,
                className: 'my-div-icon',
                html: '<img src="' + iconPositionUrl + '" style="height:26px; width:26px;"/>',
                popupAnchor: [0,0],
                iconAnchor: [13,0],
                iconSize:[0,0],
            }),
        }
    );

    if(searchPhrase !== null){
        marker.bindTooltip(`${langTexts.markerWithSearch.replace('{searchPhrase}', searchPhrase)}`);
    } else {
        marker.bindTooltip(`${langTexts.markerDefault}`);
    }

    marker.openTooltip();
    marker.addTo(map);
    positionMarker = marker;
    marker.on('click', function(e){
        removePositionMarker();
    });
}

function removePositionMarker()
{
    if (positionMarker) {
        positionMarker.remove();
        positionMarker = null;
    }
}

function toggleAjaxLoading(target)
{
    var targetElement = $('#' + target);
    if(targetElement.length === 0)
    {
        var targetElement = $('.' + target);
    }

    if(targetElement.length != 0)
    {
        if(targetElement.hasClass('ajaxloading'))
        {
            targetElement.removeClass('ajaxloading');
            targetElement.find('.divsvg').remove();

        } else {
            targetElement.addClass('ajaxloading');
            var object = $('<object type="image/svg+xml" data="/loader.svg"></object>');
            var div = $('<div class="divsvg"></div>');
            div.append(object);
            targetElement.prepend(div);
        }
    }
}

//pri otevirani/zavirani filtrů se meni vyska stranky, takze se musi mapa a popup prepocitat (po 500ms kvuli jsToggle gigaprint animaci)
function resizeMapAfterTogglingFilters()
{
    setTimeout(() => {
        map.invalidateSize();
    }, 500);

    if(map._popup){
        map._popup.update();  //pokud se prechazi z desktopu s otevrenym popupem na mobil a klikne se na filtry tak se karta zarovna
    }
}

//nepouziva se uz
function parseViewportToPoints() {
    var viewport = map.getBounds();

    //southWest (LeftBottom)
    var pointLB = {
        lng: viewport._southWest.lng,
        lat: viewport._southWest.lat,
    };

    //northEast (RightTop)
    var pointRT = {
        lng: viewport._northEast.lng,
        lat: viewport._northEast.lat,
    };

    return points = {
        'LB': pointLB,
        'RT': pointRT
    };
}


// přidal mikuš kvuli mape na route store/branches (file branchesCities.blade.php)
$('.leaflet-link').on('click', function() {
    var lat = $(this).data('lat');
    var long = $(this).data('long');
    map.setView([lat,long],12);
});

import Autocomplete from './autocomplete';
function initAutocomplete() {
    var countryId = parseInt($('#autocomplete-js-input').data('app-country-id'));
    var autocompleteProvider = 'mapy-api';
    switch (countryId) {
        case 1: // ČR
            autocompleteProvider = 'mapy-api';
            break;
        case 2: // SK
            autocompleteProvider = 'mapy-api';
            break;
        case 7: // HU
            autocompleteProvider = 'google-api';
            break;
        default:
            autocompleteProvider = 'google-api';
    }

    Autocomplete.init({
        input: '#autocomplete-js-input',
        resultContainer: '#autocomplete-js__result-container',
        iconSearch: '#autocomplete-icon-search',
        iconClose: '#autocomplete-icon-close',
        iconPositionUrl: iconPositionUrl,
        autocompleteJsInput: '#autocomplete-js-input',
        resultsProvider: autocompleteProvider,
        langTexts: langTexts,
        map: map,

        onLocationSelected: function ({ lat, lng, zoom, label }) {
            createMarkerAtLocation({ lat, lng }, label);
            map.setView([lat, lng], zoom);
        }
    });
}